import React from "react";

const Logo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    role="img"
    aria-label="TeamBoard logo"
  >
    <rect width="100" height="100" rx="20" fill="#222875" />
    <rect x="20" y="25" width="60" height="8" rx="4" fill="white" />
    <rect x="20" y="45" width="45" height="8" rx="4" fill="white" opacity="0.8" />
    <rect x="20" y="65" width="55" height="8" rx="4" fill="white" opacity="0.6" />
  </svg>
);

export default Logo;
